module.exports = __webpack_public_path__ + "img/ic_new_blue.4545a994.svg";